import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import SIPFork from "./SIP_Fork";
import SIPInfo from "./SIP_Info";
import CheckoutCartTotal from "./CheckoutCartTotal";

const hebrewLabels = {
  phone: "מספר נייד",
  nameForInvoice: "שם עבור החשבונית",
  titles: {
    billingTitle: "פרטי הלקוח",
  },
  invoiceOnDifferentName: "ארצה חשבונית על שם אחר או חברה",
  terms: {
    install: "* התשלום באתר הינו עבור הצמיגים בלבד",
    pickup: "איסוף עצמי אפשרי מהמחסן שלנו בכתובת: אליהו איתן 32, ראשון לציון",
    pickup2:
      "לאחר ההזמנה, נציג מטעמנו יצור קשר לתיאום האיסוף. אין להגיע לאסוף ללא תיאום מראש!",
  },
  companyId: "ח.פ / ע.מ",
  name: "שם מלא",
  emailaddress: "כתובת מייל",
  continue: "המשך",
  errors: {
    fullNameRequired: "נא להזין שם פרטי ושם משפחה",
    phoneFormat: "נא להזין מספר נייד ישראלי בפורמט 05XXXXXXXX",
    emailFormat: "נא להזין כתובת מייל תקינה",
  },
};

// Validation functions
function validateFullName(name) {
  const nameParts = name.trim().split(/\s+/);
  return nameParts.length >= 2 && nameParts.every(part => part.length > 0);
}

function validateIsraeliPhone(phone) {
  // Clean phone number by removing spaces, dashes, and other non-digit characters except leading digits
  const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
  const phoneRegex = /^05\d{8}$/;
  return phoneRegex.test(cleanPhone);
}

// Helper function to clean phone input
function cleanPhoneInput(phone) {
  return phone.replace(/[\s\-\(\)]/g, '');
}

// Email validation function
function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email.trim());
}

const styles = (theme) => ({
  content: {
    padding: 16,
  },
  sipGrid: {
    width: "100%",
  },
  "@media (min-width: 1024px)": {
    sipGrid: {
      width: "initial",
    },
  },
  invoiceNameText: {
    color: "#858585",
    fontSize: 13,
  },
  formControl: {
    margin: theme.spacing() / 2,
    width: "90%",
  },
  commentsSection: {
    padding: 8,
  },
  formLabel: {
    padding: theme.spacing(),
    paddingLeft: 0,
  },
  totalsRow: {
    margin: 8,
  },
  sectionTitle: {
    fontSize: 20,
  },
  button: {
    width: "90%",
  },
});

class Personal extends React.Component {
  state = {
    validationErrors: {
      name: false,
      phone: false,
      email: false,
    }
  };

  handleChange = (event) => {
    const { value, name, id } = event.target;
    let _value = value;
    const fieldId = id || name;

    if (id === "custom_invoice_name_cb" && !event.target.checked) {
      _value = "";
    }

    // Real-time validation
    const validationErrors = { ...this.state.validationErrors };
    
    if (fieldId === "name") {
      validationErrors.name = _value.trim().length > 0 && !validateFullName(_value);
    } else if (fieldId === "phone") {
      // Clean phone input and update the value
      _value = cleanPhoneInput(_value);
      validationErrors.phone = _value.trim().length > 0 && !validateIsraeliPhone(_value);
    } else if (fieldId === "emailaddress") {
      validationErrors.email = _value.trim().length > 0 && !validateEmail(_value);
    }

    this.setState({ validationErrors });
    this.props.onFormFieldChange(fieldId, _value);
  };

  handleBlur = (event) => {
    // Ensure data is saved to localStorage when user exits the field
    const { value, name, id } = event.target;
    const fieldId = id || name;
    let _value = value;

    if (fieldId === "phone") {
      _value = cleanPhoneInput(_value);
    }

    // Explicitly save to localStorage on blur
    this.props.onFormFieldChange(fieldId, _value);
  };

  render() {
    const {
      classes,
      data,
      handleSipChange,
      catalog,
      getInstallCities,
      onChangeInstallCity,
      onPickShop,
      onClearPickShop,
      onFormFieldChangeForShipping,
      onPickInstallDate,
      onPickInstallSlot,
      reportLike,
    } = this.props;
    const { checkout, stats, cart } = catalog;
    const {
      name = "",
      phone = "",
      emailaddress = "",
      nameforinvoice = "",
      companyOrBussinessVatId = "",
      custom_invoice_name_cb = "",
    } = data;

    const inputPropsForEmails = {
      type: "email",
    };

    return (
      <div className={classes.content}>
        <Grid container spacing={0}>
          <Grid item lg={6}>
            <Typography component="h2" className={classes.sectionTitle}>
              {hebrewLabels.titles.billingTitle}
            </Typography>

            <FormControl component="fieldset" className={classes.formControl}>
              <TextField
                id="name"
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                label={hebrewLabels.name}
                className={classes.textField}
                value={name}
                margin="normal"
                error={this.state.validationErrors.name}
                helperText={this.state.validationErrors.name ? hebrewLabels.errors.fullNameRequired : ""}
              />
            </FormControl>

            <FormControl component="fieldset" className={classes.formControl}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      custom_invoice_name_cb === "custom_invoice_name"
                        ? true
                        : false
                    }
                    id="custom_invoice_name_cb"
                    onChange={this.handleChange}
                    value="custom_invoice_name"
                    color="primary"
                  />
                }
                label={
                  <span className={classes.invoiceNameText}>
                    {hebrewLabels.invoiceOnDifferentName}
                  </span>
                }
              />
            </FormControl>

            {custom_invoice_name_cb === "custom_invoice_name" && (
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  id="nameforinvoice"
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  label={hebrewLabels.nameForInvoice}
                  className={classes.textField}
                  value={nameforinvoice}
                  margin="normal"
                />
              </FormControl>
            )}

            {custom_invoice_name_cb === "custom_invoice_name" && (
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  id="companyOrBussinessVatId"
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  label={hebrewLabels.companyId}
                  className={classes.textField}
                  value={companyOrBussinessVatId}
                  margin="normal"
                />
              </FormControl>
            )}

            <FormControl component="fieldset" className={classes.formControl}>
              <TextField
                id="phone"
                type="tel"
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                label={hebrewLabels.phone}
                className={classes.textField}
                value={phone}
                margin="normal"
                error={this.state.validationErrors.phone}
                helperText={this.state.validationErrors.phone ? hebrewLabels.errors.phoneFormat : ""}
                placeholder="05XXXXXXXX"
              />
            </FormControl>

            <FormControl component="fieldset" className={classes.formControl}>
              <TextField
                id="emailaddress"
                inputProps={inputPropsForEmails}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                label={hebrewLabels.emailaddress}
                className={classes.textField}
                value={emailaddress}
                margin="normal"
                error={this.state.validationErrors.email}
                helperText={this.state.validationErrors.email ? hebrewLabels.errors.emailFormat : ""}
              />
            </FormControl>
          </Grid>

          <Grid item lg={6} className={classes.sipGrid}>
            <SIPFork
              sip={checkout.sip}
              cart={cart}
              onChangeSip={handleSipChange}
              onContinue={this.onContinueSIPFork}
            />

            <SIPInfo
              checkout={checkout}
              sip={checkout.sip}
              stats={stats}
              cart={cart}
              getInstallCities={getInstallCities}
              onChangeInstallCity={onChangeInstallCity}
              onPickShop={onPickShop}
              onClearPickShop={onClearPickShop}
              onPickInstallDate={onPickInstallDate}
              onPickInstallSlot={onPickInstallSlot}
              reportLike={reportLike}
              onFormFieldChangeForShipping={onFormFieldChangeForShipping}
            />
          </Grid>
        </Grid>

        <Divider />

        <Grid container spacing={0} className={classes.totalsRow}>
          <Grid item lg={6}>
            <CheckoutCartTotal
              checkout={checkout}
              cartProducts={catalog.cartProducts}
              cart={cart}
            />
          </Grid>

          <Grid item lg={6} className={classes.commentsSection}>
            {checkout.sip === "install" && (
              <React.Fragment>
                <Typography component="p">
                  {hebrewLabels.terms.install}
                </Typography>
              </React.Fragment>
            )}

            {checkout.sip === "pickup" && (
              <React.Fragment>
                <Typography component="p">
                  {hebrewLabels.terms.pickup}
                </Typography>
                <Typography component="p">
                  {hebrewLabels.terms.pickup2}
                </Typography>
              </React.Fragment>
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

Personal.propTypes = {
  classes: PropTypes.object.isRequired,
  onContinue: PropTypes.func.isRequired,

  // Action handlers
  handleSipChange: PropTypes.func.isRequired,

  getInstallCities: PropTypes.func.isRequired,
  onChangeInstallCity: PropTypes.func.isRequired,
  onPickShop: PropTypes.func.isRequired,
  onFormFieldChangeForShipping: PropTypes.func.isRequired,
  onClearPickShop: PropTypes.func.isRequired,
  onPickInstallDate: PropTypes.func.isRequired,
  onPickInstallSlot: PropTypes.func.isRequired,
  reportLike: PropTypes.func.isRequired,

  catalog: PropTypes.object,
  checkout: PropTypes.object,
  data: PropTypes.object,
  onFormFieldChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(Personal);
